<template>
  <div>
    <div class="tabType3">
      <ul>
        <li v-for="(item, key) in pkgsTapData" :key="key" :class="{'on': selected.group === key }">
          <a @click="changeTab(key)"><span>{{item[0].group}}</span></a>
        </li>
      </ul>
    </div>

    <swiper class="swiper" :options="swiperOption" @slideChange="slideChange()">
      <swiper-slide class="item" v-for="(item, i) in pkgsTapData" :key="i">
        <div class="tabCont tabContBorder on">
          <div class="tabCont_top">
            <div v-if="pkgsTapData[i][0].group === 'POWER TRAIN'" class="title">POWER TRAIN<br>WARRANTY</div>
            <div v-else class="title">{{pkgsTapData[i][0].group}}</div>
            <div v-if="pkgsTapData[i][0].group !== 'POWER TRAIN'"> <a class="link" @click="popupOpen(true)">상세보기</a></div>
          </div>

          <div class="fs12">
            <span v-if="pkgsTapData[i][0].group === 'STANDARD'">차량 관리에 꼭 필요한 항목만 모아둔 상품 구성을 합리적인 가격으로 만나보세요.</span>
            <span v-else-if="pkgsTapData[i][0].group === 'PREMIUM'">차량 관리에 필요한 모든 서비스와 혜택을 통해<br>차량관리를 걱정 없이 편안하게 경험해보세요.</span>
          </div>
          <pkg-tab-prod-list :selected_pkg="pkgsTapData[i][0].id"/>
          <div style="position: absolute; bottom: 17px;display: flex;align-items: center;">
            <i class="icon information small"></i>
            <a class="link"  @click="$router.push(`/guide/total?group=${pkgsTapData[i][0].group}`)" 
              style="font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              text-decoration-line: underline;
              color: #1C69D4;
              vertical-align: super;
              text-underline-offset: 3px;">구독 신청 방법 및 이용 방법</a>
          </div>
        </div>
      </swiper-slide>

    </swiper>

    <div class="tglWrap faq p20 bd0">
      <div class="sub_copy">
        <p class="sub_title">
          BMW ServiceCare+ <br>
          멤버십 서비스 비용 확인하기
        </p>
      </div>
      <ul>
        <li class="bd0" :class="[tglOn ? 'tgl on' : 'tgl' ]">
          <div class="tglCon" style="background:none;padding:30px 0;">

            <div class="inputWrap">
              <select-box title="차량선택"
                :items="vehicleSelectData"
                :selected="selected.vehicle"
                :val.sync="selected.vehicle"
                :option-val-id="true"
                :closed="true"
              ></select-box>
            </div>
            <div class="inputWrap">
              <select-box title="멤버십 선택" 
                :items="pkgs" 
                :selected="selected.pkg" 
                :val.sync="selected.pkg"
                :closed="true"
              ></select-box>
            </div>
            <div class="inputWrap">
              <select-box title="최초등록일 입력해주세요."
                input_type="date"
                :val.sync="selected.term"
                :date.sync="selected.date"
                :setDate.sync="selected.setDate"
              ></select-box>
            </div>
            <div class="flex spaceBetween mb10px">
              <div>서비스 기간</div>
              <div class="b400" :multiline="true">{{ getSubscPeriod() }}</div>
            </div>
            <div class="flex spaceBetween mb10px">
              <div v-if="costState">서비스 비용 (12개월)</div>
              <!-- <div v-if="!costState">해당 연차는 가입이 불가능합니다.</div> -->
              <div v-if="costState" class="b400" :multiline="true">
                <div class="price">{{costService | currency}}원</div>
                <div class="Pricedesc alignR">(VAT포함)</div>
              </div>
            </div>
            <div v-if="costPromo" class="flex spaceBetween">
              <div>프로모션가</div>
              <div>{{ (costService-costPromo) | currency}} 원</div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="notice p20">
      <div class="notice_title">유의 사항</div>
      <ul class="listDot boldDot mgt2">
        <li>서비스 기간은 가입승인 완료 후 익일 00시부터 12개월 입니다.</li>
        <li>가입승인일은 영업일 기준 약 4일 소요되며, 가입승인 완료는 문자로 안내됩니다.</li>
        <li>M시리즈: M 하이 퍼포먼스 및 순수 전기차는 가입 불가합니다.</li>
        <li>Standard와 Premium은 차량 등록일로부터 60개월 초과인 경우만 가입 가능합니다.<br>
          (M시리즈: M 하이 퍼포먼스 및 순수 전기차는 가입 불가합니다.)
        </li>
        <li>{{$store.state.insuranceName}}는 차량등록일로부터 60개월 초과 ~ 96개월 이하 및 주행거리 18만KM 이하일 때만 가입 가능합니다.<br>
          (Z 시리즈, M시리즈: M 하이 퍼포먼스, 순수 전기차는 가입 대상에 제외되며 일부 차량 및 차량 상태에 따라 가입이 불가능 할 수 있습니다.)
        </li>
        <li>멤버십 가격은 12개월 기준 서비스 구독 금액이며, 가입 기간동안의 사용 유무와 상관없이 12개월 이후 자동사용 만료됩니다.</li>
        <li>상기 멤버십 가격은 예고 없이 변경 될 수 있습니다.</li>
        <li>상기 멤버십은 예고 없이 판매 중단될 수 있습니다.</li>
        <li>BMW Vantage 내 소유차량 등록이 된 차량에 한하여 서비스 이용이 가능합니다.</li>
        <li>{{$store.state.msg_}}</li>
      </ul>
    </div>

    <popup-alert v-if="activate" title="안내" @close="activate = false;">
      <popup-msg type="SUBSC_INSURANCE_NOTI"/>
    </popup-alert>

    <popup-full v-if="popupActivate" @close="popupOpen(false)">

      <template #title>{{pkgs[selected.pkg].pkg.toUpperCase()}} 혜택 상세보기</template>

      <template #content>
        <ul>
          <li v-for="(prod, i) in pkgProds" :key="i" class="prodWrap">
            <template v-for="(content, j) in prod.content.split('\n')" >
              <div v-if="j === 0" class="WBkeepAll mb20px prodTitle"
                   :key="`pkg-prod-content-${j}`">
                {{content}}<br>
              </div>
            </template>
            <div class="prodSubtitle">
              {{prodUnitInfo(prod.unit, prod.unit_type)}}
              <span v-if="prod.unit_type === UNIT_TYPE_CURRENCY">(VAT포함)</span>
            </div>
            <template v-for="(content, j) in prod.content.split('\n')" >
            <span v-if="j !== 0" class="WBkeepAll prodDesc"
                  :style="`${(content.includes('※') || content.includes('예시)')) ? 'font-size:12px;' : ''}`"
                  :key="`pkg-prod-content-${j}`">
              {{content}}<br>
            </span>
            </template>
          </li>
        </ul>
      </template>
    </popup-full>
  </div>

</template>


<script>
import Const from "../../helpers/Const";
import Format from "../../helpers/Format";
import { PromoMixin } from '@/mixins/PromoMixin';

import PkgTabProdFtdList from "@/views/Pkg/PkgTabProdFtdListView";
import PkgTabProdList from "@/views/Pkg/PkgTabProdListView";
import SelectBox from "@/components/Select/SelectBox";

import PopupFull from '@/components/Popup/PopupFull.vue'
import PopupAlert from '@/components/Popup/PopupAlert.vue'
import PopupMsg from '@/components/Popup/PopupMsgTemplate'

export default {
  mixins:[PromoMixin],
  filters: Format,
  components: {
    PkgTabProdFtdList,
    PkgTabProdList,
    SelectBox,

    PopupFull,
    PopupAlert,
    PopupMsg,
  },

  created() {
    const currentDate = new Date();
    const previousDate = new Date(currentDate);
    previousDate.setMonth(currentDate.getMonth() - 60);
    this.selected.setDate = previousDate.toISOString();

    this.selected.pkg = this.defaultPkg;
    this.selected.group = (this.pkgs[this.defaultPkg].group) ? this.pkgs[this.defaultPkg].group : this.pkgs[this.defaultPkg].title;
  },

  props: {
    val: null,
  },

  data(){
    return{
      activate: false,

      pkgs: this.$store.state.pkgs,
      groups: [],
      prods: this.$store.state.prods,
      vehicleCats: this.$store.state.vehicleCats,

      selected: {
        group: 0,
        insurance: true,
        pkg: 0,
        vehicle: 0,
        term: 0,
        date: null,
        setDate: null,
        type: 0,
        isHideDate: true
      },
      tglOn: true,
      popupActivate: false,
      UNIT_TYPE_CURRENCY: Const.PKG_PROD_UNIT_TYPE_CURRENCY,
      UNIT_TYPE_NUMBER: Const.PKG_PROD_UNIT_TYPE_NUMBER,
      tabML: 0,

      swiperOption: {
        loop: false,
        slidesPerView: 1, //화면에 slide 노출 개수
        spaceBetween: 5, //거리
        centeredSlides: true,
        hashNavigation: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },

  computed: {
    defaultPkg() { return Object.keys(this.pkgs)[0]},

    costState() {
      let state = false;
      const vehicleCat = this.vehicleCats[this.selected.pkg];
      if (vehicleCat===undefined) return state;

      const vehicleData = vehicleCat[this.selected.vehicle];
      if (vehicleData) {
        const cost = vehicleData.costs[this.selected.term];
        if(cost) state = cost.state;
      }
      return state;
    },

    costPromo() {
      let discount = 0;
      const pkg = this.pkgs[this.selected.pkg]
      if (pkg === undefined) return discount;

      if(pkg.promo)
        discount = this.setPromoRate(this.pkgs[this.selected.pkg].promo, this.costService);
      return discount;
    },

    costService() {
      let price = 0;
      const vehicleData = this.vehicleCats[this.selected.pkg][this.selected.vehicle];
      if (vehicleData) {
        const cost = vehicleData.costs[this.selected.term];
        price = cost.year;
      }
      return price;
    },

    pkgsTapData(){
      let pkgs = {};
      let sortedPkgs = {};

      Object.keys(this.pkgs).forEach(p => {
        let pkg = this.pkgs[p];
        let group = (pkg.group) ? pkg.group : pkg.title;
        if(pkgs[group] === undefined) pkgs[group] = [];
        pkgs[group].push(pkg);
      });

      let groups = Object.getOwnPropertyNames(pkgs);
      groups.sort((a, b) => pkgs[a].length - pkgs[b].length);
      groups.forEach(group=>{
        sortedPkgs[group] = pkgs[group]
        this.groups.push(group);
      });
      return sortedPkgs;
    },

    vehicleSelectData() {
      let vehicleData = [];
      let vehicleCat = null
      let keys = this.vehicleCats[this.selected.pkg];
      let selectedVehicle = 0;
      let $this = this;

      if (keys !== undefined){
        Object.keys(this.vehicleCats[this.selected.pkg]).forEach(v => {
          vehicleCat = {...this.vehicleCats[this.selected.pkg][v]};
          vehicleData[vehicleCat.title] = vehicleCat;
          vehicleData[vehicleCat.title].ids = [vehicleCat.id];
        });
      }

      let tmpArr = [];
      tmpArr.push({id:0, title:'차량을 선택해주세요.'});
      for (let key in vehicleData) {
        tmpArr[tmpArr.length] = vehicleData[key]
        if (this.selected.vehicle === vehicleData[key].id) selectedVehicle = this.selected.vehicle;
      }
      $this.selected.vehicle = selectedVehicle;

      tmpArr.sort(function (a, b) {
        return a.seq < b.seq ? -1 : a.seq > b.seq ? 1 : 0;
      })

      return tmpArr;
    },

    pkgProds() {
      let prods = this.prods[this.selected.pkg].flatMap(prod=>prod);
      prods.sort(function (a,b) {
        if (a.seq > b.seq) return 1;
        if (a.seq < b.seq) return -1;
        return 0;
      });
      return prods;
    },
  },

  methods: {

    changeTab(selectPkgGroup) {
      this.selected.group = selectPkgGroup;
      this.tglOn = true;

      let mySwiper = document.querySelector('.swiper-container').swiper
      mySwiper.slideTo(this.groups.indexOf(selectPkgGroup));
    },

    slideChange(){
      let mySwiper = document.querySelector('.swiper-container').swiper
      this.selected.group = this.groups[mySwiper.activeIndex];
    },

    setSelectedPkg(){

      let selectPkgs = this.pkgsTapData[this.selected.group];

      for(let i in selectPkgs){
        if (this.selected.pkg === undefined) break;
        let pkg = selectPkgs[i];
        if (Number(pkg.id) === Number(this.selected.pkg)) return;
      }
      let selectPkg = null;
      if(selectPkgs) {
        if(selectPkgs.length === 1) {
          selectPkg = selectPkgs[0];
        } else {
          selectPkg = selectPkgs[0];
        }
        this.selected.pkg = selectPkg.id;
      }

    },
    popupOpen(opened) {
      this.popupActivate = opened;
    },
    prodUnitInfo(unit, unit_type) {
      const unitInt = parseInt(unit)
      switch (unit_type) {
        case this.UNIT_TYPE_NUMBER:
          if(unitInt === 999)
            return `제공 횟수 | 무한`;
          else
            return `제공 횟수 | 연 ${unitInt} 회`;
        case this.UNIT_TYPE_CURRENCY:
          return `제공 금액 | 연 ${String(Const.getPriceAddVatRound(unitInt)).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원`;
      }
    },
  },

  watch: {
    'selected.group'() {
      this.setSelectedPkg();
    },

    'selected.pkg'(value) {
      this.$emit('update:pkg', value);
      const pkg = this.pkgs[value];
      if(pkg === undefined) return;

      this.selected.group = this.pkgs[value].group;
      this.selected.insurance = this.pkgs[value].is_assurance;
      this.changeTab(this.selected.group);
    },

    'selected.vehicle'(value) {
      this.$emit('update:vehicle', value);
    },

    'selected.term'(value) {
      this.$emit('update:term', value);

    },

    'selected.date'(value) {
      this.$emit('update:date', value);
    },

    'selected.isHideDate'(value) {
      this.$emit('update:isHideDate', value);
    },

    'selected.insurance'(newV) {
      if(newV && this.$route.name !== 'SubscGuide') this.activate = true;
      this.setSelectedPkg();
    },
  },
};
</script>

<style scoped>
  .fs12 {
    font-size: 12px;
  }
  .mt0 {
    margin-top: 0px;
  }
  .p20 {
    padding: 20px;
  } 
  .bd0 {
    border: 0px;
  }
  .tabCont.tabContBorder.on{
    margin: auto;
    height: 100vw;
  }
  .prodSubtitle {
    color: #1C69D4;
  }
</style>